import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const fetchClubs = async () => {
  try {
    const response = await axios.get(`${API_URL}/clubs`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export { fetchClubs };